import ApiService from "@/core/services/ApiService"; // Importa el servicio correcto
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { EmailTemplate } from "../models";

@Module({ namespaced: true, name: "EmailTemplatesModule" })
export class EmailTemplatesModule extends VuexModule {
  public templates: EmailTemplate[] = [];

  @Mutation
  public SET_TEMPLATES(templates: EmailTemplate[]) {
    this.templates = templates;
  }

  @Action
  async fetchTemplates() {
    return ApiService.get("/plantillas-email")
      .then(({ data }) => {
        this.SET_TEMPLATES(data);
      })
      .catch((err) => {
        console.error("Error cargando plantillas:", err);
        throw err;
      });
  }

  @Action
  async updateTemplate(payload: { id: string; data: Partial<EmailTemplate> }) {
    return ApiService.put(
      `/plantillas-email/${payload.id}`,
      payload.data
    ).catch((err) => {
      console.error("Error actualizando plantilla:", err);
      throw err;
    });
  }
}
